<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div class="vx-row">
      <vx-card>
        <vs-table
          :max-items="descriptionItems[1]"
          search
          pagination
          :description="false"
          :data="eventActionList"
          :description-items="descriptionItems"
          description-title="Registries"
          description-connector="of"
          description-body="Pages"
        >
          <template slot="header">
            <div
              style="margin-right: auto; font-size: 1.5rem; font-weight: 550"
            >
              {{ $t("admin.label.Hooks Event Actions") }}
            </div>
          </template>
          <template slot="header">
            <div class="order-1">
              <v-select
                v-model="selectedHeaderStatus"
                :options="output"
                label="value"
                :placeholder="$t('placeholder.label.SelectOne')"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="min-w-200 w-full mb-2"
              >
              </v-select>
            </div>
          </template>
          <template slot="thead">
            <vs-th>{{ $t("admin.label.Transaction Date") }}</vs-th>
            <vs-th>{{ $t("admin.label.Event Action") }}</vs-th>
            <vs-th>{{ $t("admin.label.Action") }}</vs-th>
            <vs-th>{{ $t("admin.label.Status") }}</vs-th>
            <vs-th class="tHeadCenter">
              {{ $t("admin.label.Command") }}
            </vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr
              :key="index"
              :data="eventActionList"
              v-for="(eventActionList, index) in data"
            >
              <vs-td :data="eventActionList.transactionDate">{{
                getDate(eventActionList.transactionDate)
              }}</vs-td>
              <vs-td :data="eventActionList.eventAction">{{
                eventActionList.eventAction
              }}</vs-td>
              <vs-td :data="eventActionList.actionName">{{
                eventActionList.actionName
              }}</vs-td>
              <vs-td :data="eventActionList.status">{{
                eventActionList.status
              }}</vs-td>
              <vs-td :data="eventActionList.jsonData">
                <div class="text-center">
                  <feather-icon
                    title="Command"
                    icon="EyeIcon"
                    @click="openPopup(eventActionList.jsonData)"
                    class="text-primary icon_row"
                    svgClasses="w-5 h-5 stroke-current text-primary"
                  />
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <vs-popup
          :title="$t('admin.labelCommandDetails')"
          :active.sync="filterPopup"
          class="popup-close"
        >
          <div v-if="parsedData" class="vx-row">
            <div class="vx-col font-bold">
              {{ $t("admin.label.DateFormat") }} :
            </div>
            <div class="vx-col">{{ parsedData.dateFormat }}</div>
          </div>
          <div v-if="parsedData" class="vx-row">
            <div class="vx-col font-bold">{{ $t("admin.label.Locale") }} :</div>
            <div class="vx-col">{{ parsedData.locale }}</div>
          </div>
          <div v-if="parsedData" class="vx-row">
            <div class="vx-col font-bold">
              {{ $t("admin.label.SystemDate") }}:
            </div>
            <div class="vx-col">{{ parsedData.systemDate }}</div>
          </div>
        </vs-popup>
      </vx-card>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { AtomSpinner } from "epic-spinners";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
import { mapState } from "vuex";
export default {
  data() {
    return {
      loading: false,
      filterPopup: false,
      descriptionItems: [5, 10, 15],
      output: ["All", "processed", "UnProcessed", "Canceled", "Failed"],
      selectedHeaderStatus: "All",
      parsedData: null,
    };
  },

  components: { "v-select": vSelect, AtomSpinner },
  computed: {
    ...mapState({
      formattedDate: (state) => state.settings.selectedDateFormat,
      eventActionList: (state) => state.admin.eventActionListing,
    }),
  },
  watch: {
    selectedHeaderStatus: {
      handler: "getEventActionsByStatus",
      immediate: true,
    },
  },
  methods: {
    getDate(date) {
      return moment(date).format(this.formattedDate);
    },
    async geteventActionsListData() {
      try {
        await this.$store.dispatch("admin/setEventAction");
        this.eventActionList = response.data.pageItems;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getEventActionsByStatus() {
      this.loading = true;
      if (this.selectedHeaderStatus !== "All") {
        try {
          await this.$store.dispatch(
            "admin/setEventActionByStatus",
            this.selectedHeaderStatus.toLowerCase()
          );
          this.eventActionList = response.data.pageItems;
          this.loading = false;
        } catch (error) {
          throw Error(
            error.message.errors[0].defaultUserMessage ||
              `Api failed with status code: ${error.message.httpStatusCode}`
          );
        }
      } else {
        this.loading = true;
        this.geteventActionsListData();
        this.loading = false;
      }
    },
    openPopup(data) {
      try {
        this.parsedData = JSON.parse(data);
      } catch (e) {
        console.error("Error parsing JSON data:", e);
        this.parsedData = null;
      }
      this.filterPopup = true;
    },
  },
  async mounted() {},
};
</script>

<style lang="scss" scoped>
.vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}

.vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}

.vs-search-categeory {
  margin-top: 17px;
}
.text-status {
  margin-bottom: 2px;
  margin-right: 15px;
}
</style>
